import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SummaryDetailsComponent } from './summary-details/summary-details.component';
//import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
//import * as more from 'highcharts/highcharts-more.src';
import { SummaryTabComponent } from './summary-details/summary-tab/summary-tab.component';
import { ProfileTabComponent } from './summary-details/profile-tab/profile-tab.component';
import { FinancialsComponent } from './summary-details/financials/financials.component';
import { StatisticsComponent } from './summary-details/statistics/statistics.component';


// Pipes
import { SharedPipesModule } from '../../shared-pipes/shared-pipes.module';
import { FinancialNewsComponent } from '../../../seller/seller-dashboard/financial-news/financial-news.component';
import { StockInfoComponent } from '../../../seller/seller-dashboard/financial-news/stock-info/stock-info.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SharedTickerModule } from '../shared-ticker/shared-ticker.module';
import { DealCalandarComponent } from '../../../seller/seller-dashboard/deal-calandar/deal-calandar.component';
import { SharedFileUploadModule } from '../shared-file-upload/shared-file-upload.module';
import { SharedNotesModule } from '../shared-notes/shared-notes.module';
//export function highchartsModules() {
//    // apply Highcharts Modules to this array
//    return [more];
//}
@NgModule({
  declarations: [SummaryDetailsComponent, SummaryTabComponent, ProfileTabComponent, FinancialsComponent, StatisticsComponent,
    FinancialNewsComponent, StockInfoComponent, DealCalandarComponent,],
  imports: [
      CommonModule,
      SharedPipesModule,
      SlickCarouselModule,
      SharedTickerModule,
      SharedFileUploadModule,
      SharedNotesModule
    ],
  exports: [SummaryDetailsComponent, FinancialNewsComponent, StockInfoComponent, DealCalandarComponent],
    providers: [
        //{ provide: HIGHCHARTS_MODULES, useFactory: () => [highchartsModules] }
    ]
})
    
export class FinancialSummaryModule { }
